import React, { CSSProperties, PropsWithChildren, ReactElement, ReactNode } from 'react';
import { ErrorBoundary } from '@sentry/react';
import { GenericErrorFallback, IForbiddenErrorConfig } from './GenericErrorFallback';
import { GenericLoadingFallback } from './GenericLoadingFallback';

export interface IGenericFallbacksWrapperProps extends PropsWithChildren {
  style?: CSSProperties;
  suspenseFallback?: ReactNode;
  forbiddenFallback?: IForbiddenErrorConfig;
  /**
   * Replaces the generic error card, for a slot too small to hold it (a chip in a header, say).
   * The error is still reported to Sentry.
   */
  errorFallback?: ReactElement;
}

export function GenericFallbacksWrapper(props: IGenericFallbacksWrapperProps) {
  const { children, style, forbiddenFallback, errorFallback } = props;
  const suspenseFallback = props.suspenseFallback ?? <GenericLoadingFallback />;

  return (
    <ErrorBoundary
      fallback={
        errorFallback ??
        (({ error, resetError }) => (
          <GenericErrorFallback
            error={error}
            resetError={resetError}
            style={style ?? {}}
            forbiddenConfig={forbiddenFallback}
          />
        ))
      }
    >
      <React.Suspense fallback={suspenseFallback}>{children}</React.Suspense>
    </ErrorBoundary>
  );
}
